(function(){
  var openBtn=document.querySelector('[data-menu-open]');
  var closeBtn=document.querySelector('[data-menu-close]');
  var menu=document.querySelector('[data-menu]');
  function open(){ if(menu) menu.classList.add('is-open'); }
  function close(){ if(menu) menu.classList.remove('is-open'); }
  if(openBtn) openBtn.addEventListener('click',open);
  if(closeBtn) closeBtn.addEventListener('click',close);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
})();
